import ipList from '../ipList';
import { Switch as cSwitch } from '@coreui/vue';

export default {
  name : "policy",
  props : ["lock", "group"],
  components: { ipList, cSwitch },
  data : () => {
    return {
      model : {
        security_policy : {
        account_lock_count : 5,
        account_lock_time : 5,
        password_min_len : 10,
        password_use_spacial : true,
        password_use_alphabet : true,
        password_use_number : true,
      },
      allow_ip_agent : [],
      allow_ip_account : []
      }
    }
  },
  computed: {
  },
  methods: {
    edit: function() { this.emit('edit') },
    save: function() { this.emit('save') },
    cancel: function() { this.emit('cancel') },
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('group.security_policy.vue', 'created'); },
  destroyed: function() { console.log('group.security_policy.vue', 'destroyed'); },
  mounted: function() {
    console.log('group.security_policy.vue', 'mounted');
  },
}